/**
 * Returns an emoji icon for a given severity level.
 */
export function getSeverityIcon(severity) {
  const icons = {
    critical: "🔴",
    high: "🟠",
    medium: "🟡",
    low: "🟢",
    prerequisite: "📋",
  };
  return icons[severity] || "⚪";
}

/**
 * Maps category names to their icon filenames.
 */
export const categoryIcons = {
  AzureAD: "entra.png",
  AzureMaintenance: "AzureMaintenance.png",
  AzurePolicy: "AzurePolicy.png",
  Defender: "Defender.png",
  Exchange: "Exchange.png",
  Forms: "Forms.png",
  Intune: "Intune.png",
  Planner: "Planner.png",
  SharePoint: "Sharepoint.png",
  Teams: "Teams.png",
  "Conditional Access": "entra.png",
  "Azure AD Settings": "entra.png",
  "Device Settings": "Intune.png",
  "Defender for Office 365": "Defender.png",
  "Exchange Security": "Exchange.png",
};
